export const PET_URL = `/api/v3/pets/`;
export const PET_URL_V4 = `/api/v4/mx/pets/`;
export const SUBSCRIPTIONS_V4_BASE_URL = `/api/v4/mx/subscriptions/`; // Used for updating a pet and their meal plan in tandem
export const MIN_WEIGHT = 3;
export const MAX_WEIGHT = 180;
export const WEIGHT_ERROR = `Ollie is currently available only to pups between ${MIN_WEIGHT} and ${MAX_WEIGHT} pounds`;
export const WEIGHT_FORMAT_ERROR = `Please use a whole number for pup weight`;
export const EMPTY_PET = {
  breeds: [],
  allergies: [],
  name: '',
  birth_date: null,
};

export const PRONOUN_TYPES = {
  SUBJECT: 'Subject',
  OBJECT: 'Object',
  POSSESSIVE_ADJECTIVE: 'Possessive Adjective',
  POSSESSIVE_PRONOUNS: 'Possessive Pronouns',
  REFLEXIVE: 'Reflexive',
};

export const PERSPECTIVE_ONE = {
  [PRONOUN_TYPES.SUBJECT]: 'i',
  [PRONOUN_TYPES.OBJECT]: 'me',
  [PRONOUN_TYPES.POSSESSIVE_ADJECTIVE]: 'my',
  [PRONOUN_TYPES.POSSESSIVE_PRONOUNS]: 'mine',
  [PRONOUN_TYPES.REFLEXIVE]: 'myself',
};

export const PERSPECTIVE_TWO = {
  [PRONOUN_TYPES.SUBJECT]: 'you',
  [PRONOUN_TYPES.OBJECT]: 'you',
  [PRONOUN_TYPES.POSSESSIVE_ADJECTIVE]: 'your',
  [PRONOUN_TYPES.POSSESSIVE_PRONOUNS]: 'yours',
  [PRONOUN_TYPES.REFLEXIVE]: 'yourself',
};

export const PERSPECTIVE_THREE = {
  Female: {
    [PRONOUN_TYPES.SUBJECT]: 'she',
    [PRONOUN_TYPES.OBJECT]: 'her',
    [PRONOUN_TYPES.POSSESSIVE_ADJECTIVE]: 'her',
    [PRONOUN_TYPES.POSSESSIVE_PRONOUNS]: 'hers',
    [PRONOUN_TYPES.REFLEXIVE]: 'herself',
  },
  Male: {
    [PRONOUN_TYPES.SUBJECT]: 'he',
    [PRONOUN_TYPES.OBJECT]: 'him',
    [PRONOUN_TYPES.POSSESSIVE_ADJECTIVE]: 'his',
    [PRONOUN_TYPES.POSSESSIVE_PRONOUNS]: 'his',
    [PRONOUN_TYPES.REFLEXIVE]: 'himself',
  },
  NoGender: {
    [PRONOUN_TYPES.SUBJECT]: 'your pup',
    [PRONOUN_TYPES.OBJECT]: 'their',
    [PRONOUN_TYPES.POSSESSIVE_ADJECTIVE]: 'their',
    [PRONOUN_TYPES.POSSESSIVE_PRONOUNS]: 'theirs',
    [PRONOUN_TYPES.REFLEXIVE]: 'theirself',
  },
};

export const RECOMMENDED_COMBOS = {
  combinations: [
    {
      combination_id: 'UUID',
      name: 'Beef & Chicken Combo',
      weeks_of_food: 4,
      description: 'Enjoy two pupular recipes in a single box.',
      recipes: {
        fresh: ['beef', 'chicken'],
        baked: [],
      },
      price: '24.99',
      discounted_price: '45.00',
      discounted_price_per_week: '22.50',
      subscription_data: {
        cadence: 4,
        box_price: '39.99',
        price_per_week: '9.99',
      },
    },
  ],
  recommendation: {
    combination_id: 'UUID',
    configuration: 'F',
    calories_per_day: 1200,
    box_calories: 11956,
    pack_size: 427,
    cadence: 2,
    fresh_calories_per_day: 1200,
    baked_calories_per_day: 0,
    recipes: {
      fresh: ['beef', 'chicken'],
      baked: [],
    },
    total_price: '120.00',
    price_per_week: '60.00',
    discounted_price: '96.00',
    discounted_price_per_week: '48.00',
    required_pack_count: 28,
    required_bag_count: 0,
    available_plan_products: ['MP-FR-BEEF-427', 'MP-FR-CHIC-427'],
    items: [
      {
        sku: 'MP-FR-BEEF-427',
        quantity: 14,
        unit_price: '1.00',
        total_price: '14.00',
        discounts: {
          unit_price: '0.30',
          total_price: '4.20',
        },
      },
      {
        sku: 'MP-FR-CHIC-427',
        quantity: 14,
        unit_price: '0.90',
        total_price: '12.60',
        discounts: {
          unit_price: '0.27',
          total_price: '3.78',
        },
      },
    ],
  },
};
